import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { FORECAST_VIEW_TYPES } from './MonteCarloSimulation/ViewTypeSelector/ViewTypeSelector';
import { FORECAST_CHART_TYPES } from './MonteCarloSimulation/ColumnChart/useChartType';

const mapViewTypeToTrackingName = {
  [FORECAST_VIEW_TYPES.CALENDAR]: 'Calendar view',
  [FORECAST_VIEW_TYPES.COLUMN_CHART]: 'Column chart view'
};

const mapChartTypeToTrackingName = {
  [FORECAST_CHART_TYPES.FREQUENCY.key]: 'Distribution',
  [FORECAST_CHART_TYPES.PROBABILITY.key]: 'Probability'
};

const useForecastTrackingEvents = () => {
  const trackEvent = (eventName, payload) => {
    TrackingService.logEvent(eventName, {
      page: TRACKING.PAGES.FORECAST,
      ...payload
    });
  };

  const onChangeViewType = viewType => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: mapViewTypeToTrackingName[viewType]
    });
  };

  const onChangeColumnChartType = chartType => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: mapChartTypeToTrackingName[chartType]
    });
  };

  const onHoverColumnChartTooltip = chartType => {
    trackEvent(TRACKING.EVENTS.HOVER, {
      hover_type: TRACKING.CLICK.FORECAST.COLUMN_CHART.TOOLTIP,
      widget_name: mapChartTypeToTrackingName[chartType]
    });
  };

  const onHoverIssueStates = () => {
    trackEvent(TRACKING.EVENTS.HOVER, {
      hover_type: TRACKING.CLICK.FORECAST.ISSUES_STATES
    });
  };

  return {
    onChangeViewType,
    onChangeColumnChartType,
    onHoverColumnChartTooltip,
    onHoverIssueStates
  };
};

export default useForecastTrackingEvents;
